module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Gb-Da-Ea.2e4ee564.png";